import http from 'hub-http/clients/apiClient';
export const fetchConnectedAccounts = () => http.get('conversations-email/v1/connected-accounts/all');